import React, { useEffect, useState } from 'react'
import './CatalogPageNavigator.scss'
import { ReactComponent as ArrowCatalogPageNavigator } from '../../components/assets/CatalogPage/ArrowCatalogPageNavigator.svg'
import { useParams } from 'react-router';
import { catalogs } from '../../../constants/catalogs';


const CatalogPageNavigator = () => {
  const [scrollTop, setScrollTop] = useState(false);
  const platform = useParams().platform
  const catalogPresonal = catalogs?.find((el) => el?.link === platform)
  
  
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 350) {
        setScrollTop(true);
      } else {
        setScrollTop(false);
      }
    });
    return () => window.removeEventListener("scroll", () => {});
  }, []);
  
  const bottomToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const bottomToBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
  });
  };

  return (
    <div className='CatalogPageNavigator'>
      <button
        style={{
          display: scrollTop ? "flex" : "none",
          background: catalogPresonal?.color
        }}
        onClick={bottomToTop}
      >
        <ArrowCatalogPageNavigator />
      </button>
      <button
        onClick={bottomToBottom}
        style={{
          display: scrollTop ? "flex" : "none",
          background: catalogPresonal?.color,
          right: '123px'
        }}
      >
        <ArrowCatalogPageNavigator style={{transform: 'rotate(180deg)'}}/>
      </button>
    </div>
  )
}

export default CatalogPageNavigator